import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const SkipIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 0 18.5 9.3",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 9.3),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    children: [/*#__PURE__*/jsx("path", {
      d: "M.8 7.4c2.4-9 13.4-9 15.4 1"
    }), /*#__PURE__*/jsx("path", {
      d: "m12.2 6.9 4 1.5 1.5-4"
    })]
  });
};

export { SkipIcon };
//# sourceMappingURL=skip.js.map
